import { useSubscriptionEnrollmentAndUpgradeInfoQuery } from '../graphql/api-platform-graphql';
import { ACTIVE_SUBSCRIPTION_STATUSES, GROW_WITH_GOOGLE_PRODUCT_TYPES } from './subscription-constants';

/**
 * Result of fetching subscription information
 */

/**
 * Fetches the current user's subscription information
 *
 * This consolidates what was previously two separate calls (fetchGrowWithGoogleSubscriptionInfo
 * and fetchValuePlanSubscriptionInfo) into one to avoid duplicate network requests.
 *
 * Returns the enrolled product type which can be used to derive:
 * - isGrowWithGoogleSubscriber (check if productType is in GROW_WITH_GOOGLE_PRODUCT_TYPES)
 * - isValuePlanSubscriber (check if productType is in VALUE_PLAN_PRODUCT_TYPES)
 *
 * @param isLoggedIn - Whether the user is logged in (optional, defaults to false)
 * @returns Promise<SubscriptionInfo> - Object containing subscription product type and GWG upgrade eligibility
 */
export async function fetchSubscriptionInfo(isLoggedIn = false) {
  try {
    var _upgradePlans$some;
    // Use SubscriptionEnrollmentAndUpgradeInfo query to fetch both current subscription and available upgrades
    // Skip currentSubscriptionEnrollment for logged-out users to avoid authentication errors
    const response = await useSubscriptionEnrollmentAndUpgradeInfoQuery.fetcher({
      skipEnrollment: !isLoggedIn
    })();

    // Handle partial GraphQL responses (e.g., when currentSubscriptionEnrollment returns an error for logged-out users)
    // The query may return errors for some fields but still provide data for others
    const enrollment = response.currentSubscriptionEnrollment;
    const upgradePlans = response.subscriptionPlanUpgradesByProductFamily;

    // Get the enrolled product type if user has an active subscription
    let enrolledProductType;
    if (enrollment) {
      const hasActiveSubscription = ACTIVE_SUBSCRIPTION_STATUSES.includes(enrollment.status);
      if (hasActiveSubscription) {
        enrolledProductType = enrollment.subscribedPlan.productType;
      }
    }

    // Check if user is eligible to upgrade to a GWG plan
    const isEligibleForGrowWithGoogleUpgrade = (_upgradePlans$some = upgradePlans === null || upgradePlans === void 0 ? void 0 : upgradePlans.some(plan => GROW_WITH_GOOGLE_PRODUCT_TYPES.includes(plan.productType))) !== null && _upgradePlans$some !== void 0 ? _upgradePlans$some : false;
    return {
      enrolledProductType,
      isEligibleForGrowWithGoogleUpgrade
    };
  } catch (error) {
    // If the query fails completely, default to false
    return {
      enrolledProductType: undefined,
      isEligibleForGrowWithGoogleUpgrade: false
    };
  }
}
//# sourceMappingURL=subscription-utils.js.map